<template>
    <div :class="cssClass" ref="template">
        <div class="grid">
            <hr v-if="hrVisible" class="grid-full" />
            <div v-if="visible" class="cogi-block-title grid-half">
                <cogi-label-only label="MembreDuMenage" />
            </div>
            <cogi-button v-if="visible" cssClass="grid-half right" cssClassButton="retirer" text="RetirerCettePersonne" @click="retirerPersonne"></cogi-button>

            <cogi-regex
                cssClass="grid-half"
                @validated="validate"
                label="Prenom"
                :valideNow="valideNow"
                :required="!estChefMenage"
                v-model="personne.prenom"
                :disabled="disabled"></cogi-regex>
            <cogi-regex
                cssClass="grid-half"
                @validated="validate"
                :valideNow="valideNow"
                label="Nom"
                :required="!estChefMenage"
                v-model="personne.nom"
                :disabled="disabled"></cogi-regex>

            <cogi-date
                :visible="visible"
                :culture="culture"
                cssClass="grid-half"
                @validated="validate"
                label="DateDeNaissance"
                :valideNow="valideNow"
                v-model="personne.dateNaissance"
                :required="true"></cogi-date>
            <cogi-dropdownlist
                :visible="visible"
                :culture="culture"
                cssClass="grid-half"
                @validated="validate"
                :valideNow="valideNow"
                label="Sexe"
                :sourceItems="sourceItemsSexe"
                v-model="personne.sexe"
                :showEmptyItem="true"
                :required="true"></cogi-dropdownlist>
            <cogi-nas
                :visible="visible"
                cssClass="grid-half"
                @validated="validate"
                :valideNow="valideNow"
                v-model="personne.nas"
                :required="false"
                label="NAS"
                tooltip="<img src='../del/images/del/NAS.png' />" />
            <cogi-dropdownlist
                :visible="visible"
                :culture="culture"
                cssClass="grid-half"
                label="LienAvecLeDemandeur"
                @validated="validate"
                :valideNow="valideNow"
                :sourceItems="sourceItemsLienParente"
                v-model="personne.lien"
                :showEmptyItem="true"
                :required="true"></cogi-dropdownlist>
            <cogi-dropdownlist
                :visible="visible"
                :culture="culture"
                cssClass="grid-half"
                label="StatutDeResidence"
                @validated="validate"
                :valideNow="valideNow"
                :sourceItems="sourceItemsStatutResidence"
                v-model="personne.statutDeResidence"
                :showEmptyItem="true"
                :required="true"></cogi-dropdownlist>

            <cogi-dropdownlist
                :visible="visible"
                :culture="culture"
                cssClass="grid-half"
                @validated="validate"
                :valideNow="valideNow"
                label="PaysDeNaissance"
                :sourceItems="sourceItemsPaysNaissance"
                v-model="personne.paysDeNaissance"
                :showEmptyItem="true"
                :required="true"></cogi-dropdownlist>

            <cogi-label
                class="grid-half verticalCenter"
                :required="estRevenuTotalObligatoire"
                label="RevenuTotal"
                :dontTranslateToolTip="true"
                :tooltip="tooltipPiecesJustificatives"></cogi-label>
            <cogi-monetaire
                cssClass="grid-half left PaddingMinCOGI"
                @validated="validate"
                :valideNow="valideNow"
                v-model="personne.revenuTotal!.value"
                :required="estRevenuTotalObligatoire" />

            <cogi-dropdownlist
                :culture="culture"
                cssClass="grid-full"
                label="Situation"
                @validated="validate"
                :valideNow="valideNow"
                :sourceItems="sourceItemsSituation"
                v-model="personne.situation"
                :showEmptyItem="true"
                :required="true" />

            <cogi-label cssClass="grid-half PaddingMinCOGI" :label="libellePersonneAuxEtudes" tooltip="EstConsidereCommeEtudiantTempsPlein"></cogi-label>

            <div class="grid-half PaddingMinCOGI" style="margin-left: 118px">
                <cogi-checkbox
                    style="display: inline-block; margin-right: 10px"
                    v-model="personne.etudiantTempsPlein"
                    label="TempsPlein"
                    @change="tempsPleinChange" />
                <cogi-checkbox style="display: inline-block" v-model="personne.etudiantTempsPartiel" label="TempsPartiel" @change="tempsPartielChange" />
            </div>

            <cogi-label cssClass="grid-half PaddingMinCOGI" :label="libelleHandicapMoteur"></cogi-label>
            <div class="grid-half PaddingMinCOGI" style="margin-left: 118px; gap: 10px">
                <cogi-checkbox style="display: inline-block" v-model="personne.handicapMoteur" label="Oui" />
            </div>

            <cogi-label v-show="sousTutelleChefOuConjointVisible" cssClass="grid-half PaddingMinCOGI" label="CettePersonneEstElleSousVotreTutelle" />
            <cogi-checkbox
                :visible="sousTutelleChefOuConjointVisible"
                cssClass="grid-half PaddingMinCOGI"
                v-model="personne.sousTutelleChefOuConjoint"
                label="Oui" />

            <cogi-dropdownlist
                :visible="afficherSectionGardePartagee"
                :culture="culture"
                cssClass="grid-half"
                label="SiVousAvezLaGardePartagee"
                @validated="validate"
                :valideNow="valideNow"
                :sourceItems="choixGardePartage"
                v-model="personne.gardePartage"
                :showEmptyItem="true"
                :required="true" />
            <span v-if="afficherSectionGardePartagee" class="grid-half"></span>
            <cogi-label cssClass="grid-half" v-if="afficherSectionGardePartagee" label="SiGardePartageeNonDecrite" />

            <cogi-yesno
                :visible="afficherSectionQuestionPensionAssurance"
                cssClass="grid-full"
                cssClassLabel="grid-half"
                cssClassRadio="grid-half left"
                @validated="validate"
                :valideNow="valideNow"
                :label="libellePensionAlimentaire"
                groupName="yesNoPensionAlimentaire"
                :required="true"
                v-model="personne.pensionAlimentaire"></cogi-yesno>
            <cogi-yesno
                :visible="afficherSectionQuestionPensionAssurance"
                cssClass="grid-full"
                cssClassLabel="grid-half"
                cssClassRadio="grid-half left"
                @validated="validate"
                :valideNow="valideNow"
                :label="libellePensionVeteran"
                groupName="pensionVeteran"
                :required="true"
                v-model="personne.pensionVeteran"></cogi-yesno>
            <cogi-yesno
                :visible="afficherSectionQuestionPensionAssurance"
                cssClass="grid-full"
                cssClassLabel="grid-half"
                cssClassRadio="grid-half left"
                @validated="validate"
                :valideNow="valideNow"
                :label="libelleRevenuAssuranceInvalidite"
                groupName="ysnAssuranceInvalidite"
                :required="true"
                v-model="personne.assuranceInvalidite"></cogi-yesno>
        </div>
    </div>
</template>
<script setup lang="ts">
    import { ref, computed, watch, getCurrentInstance } from 'vue'
    import CogiRegex from './CogiRegex.vue'
    import CogiDropdownlist from './CogiDropdownlist.vue'
    import CogiLabel from './CogiLabel.vue'
    import CogiButton from './CogiButton.vue'
    import CogiLabelOnly from './CogiLabelOnly.vue'
    import CogiCheckbox from './CogiCheckbox.vue'
    import CogiNas from './CogiNas.vue'
    import CogiMonetaire from './CogiMonetaire.vue'
    import CogiDate from './CogiDate.vue'
    import CogiYesno from './CogiYesno.vue'
    import { ValidatorAccumulatorVueComponent, ValidatorAccumulator, ValidationStatutPoco } from './helpers/validatorAccumulator'
    import { DateUtil } from './helpers/dateutil'
    import { del } from '../../../clients/delclient'
    import { useI18n } from 'vue-i18n'
    const i18n = useI18n()

    interface IPropsPersonne {
        sourceItemsSexe: del.ListItem[]
        sourceItemsLienParente: del.ListItem[]
        sourceItemsLienParentesEstSansSousTutelleChefOuConjointPossible: Array<string>
        sourceItemsPaysNaissance: del.ListItem[]
        sourceItemsStatutResidence: del.ListItem[]
        sourceItemsSituation: del.ListItem[]
        valideNow: boolean
        cssClass: string
        estChefMenage?: boolean
        lienParentePourGardePartagee: string
        utiliseGardePartagee: boolean
        currentIndex?: number
        urlPiece: string
        pourcentageGardePartage?: number
        culture: string
    }

    const props = withDefaults(defineProps<IPropsPersonne>(), {
        valideNow: false,
        cssClass: '',
        estChefMenage: false,
        lienParentePourGardePartagee: 'Invalide',
        utiliseGardePartagee: true,
        currentIndex: 0,
        urlPiece: '',
        culture: 'fr',
    })

    const personne = defineModel<del.PersonneModel>({ required: true })

    const validatorAccumulator = ref(new ValidatorAccumulatorVueComponent(new ValidatorAccumulator()))
    const instance = getCurrentInstance()

    const emit = defineEmits<{
        retirerPersonne: []
        validated: [boolean]
    }>()

    const visible = computed(() => {
        return !props.estChefMenage
    })

    const hrVisible = computed(() => {
        return props.currentIndex! > 0
    })

    const sousTutelleChefOuConjointVisible = computed(() => {
        return (
            personne.value.lien != undefined &&
            personne.value.lien != '' &&
            !props.sourceItemsLienParentesEstSansSousTutelleChefOuConjointPossible.includes(personne.value.lien)
        )
    })

    const disabled = computed(() => {
        return props.estChefMenage
    })

    const afficherSectionGardePartagee = computed(() => {
        return props.utiliseGardePartagee && !props.estChefMenage && personne.value.lien == props.lienParentePourGardePartagee
    })

    const estEtudiant = computed(() => {
        return personne.value.etudiantTempsPlein || personne.value.etudiantTempsPartiel
    })

    const estMajeur = computed(() => {
        return obtenirEstMajeur(personne.value.dateNaissance)
    })

    const estRevenuTotalObligatoire = computed(() => {
        return props.estChefMenage || (estMajeur.value && !estEtudiant.value)
    })

    const afficherSectionQuestionPensionAssurance = computed(() => {
        return !estEtudiant.value && (props.estChefMenage || estMajeur.value)
    })

    const tooltipPiecesJustificatives = computed(() => {
        return i18n.t('TooltipRevenuTotal', [props.urlPiece])
    })

    const libellePensionAlimentaire = computed(() => {
        return props.estChefMenage ? 'RecevezVousUnePensionAlimentaire' : 'CettePersonneRecoitElleUnePensionAlmentaire'
    })

    const libellePensionVeteran = computed(() => {
        return props.estChefMenage ? 'RecevezVousUnePensionDeVeteran' : 'CettePersonneRecoitElleUnePensionDeVeteran'
    })

    const libelleRevenuAssuranceInvalidite = computed(() => {
        return props.estChefMenage ? 'RecevezVousUneAssuranceInvalidite' : 'CettePersonneRecoitElleUneAssuranceInvalidite'
    })

    const libellePersonneAuxEtudes = computed(() => {
        return props.estChefMenage ? 'SiVousEtesPresentementAuxEtudes' : 'SiCettePersonneEstPresentementAuxEtudes'
    })

    const libelleHandicapMoteur = computed(() => {
        return props.estChefMenage ? 'EtesVousAtteintDunHandicapMoteur' : 'CettePersonneEstElleAtteinteDunHandicapMoteur'
    })

    function retirerPersonne() {
        emit('retirerPersonne')
    }

    function validate(newValue: boolean) {
        let validationStatut: ValidationStatutPoco = validatorAccumulator.value.validated(newValue)

        if (!validationStatut.validationCompleted) return

        emitValidated(validationStatut.hasError)
    }

    function emitValidated(hasError: boolean) {
        emit('validated', hasError)
    }

    function obtenirEstMajeur(dateDeNaissance: Date | undefined): boolean {
        if (dateDeNaissance === undefined) return false
        return DateUtil.estMajeur(dateDeNaissance)
    }

    function tempsPleinChange(): void {
        console.log('tempsPleinChange')
        if (!personne.value.etudiantTempsPlein) return
        personne.value.etudiantTempsPartiel = false
    }

    function tempsPartielChange(): void {
        console.log('tempsPartielChange')
        if (!personne.value.etudiantTempsPartiel) return
        personne.value.etudiantTempsPlein = false
    }

    const choixGardePartage: del.ListItem[] = [
        new del.ListItem({
            listItemId: 0,
            value: del.GardePartageEnum.Exclusive,
            description: i18n.t('GardeComplete', [], { locale: 'fr' }),
            descriptionAnglais: i18n.t('GardeComplete', [], { locale: 'en' }),
        }),
        new del.ListItem({
            listItemId: 1,
            value: del.GardePartageEnum.PlusDeXPourcent,
            description: i18n.t('GardePlusDe', [props.pourcentageGardePartage], { locale: 'fr' }),
            descriptionAnglais: i18n.t('GardePlusDe', [props.pourcentageGardePartage], { locale: 'en' }),
        }),
        new del.ListItem({
            listItemId: 2,
            value: del.GardePartageEnum.MoinDeXPourcent,
            description: i18n.t('GardeMoinsDe', [props.pourcentageGardePartage], { locale: 'fr' }),
            descriptionAnglais: i18n.t('GardeMoinsDe', [props.pourcentageGardePartage], { locale: 'en' }),
        }),
    ]

    watch(
        () => props.valideNow,
        newValue => {
            if (!newValue) return

            let startValidation = validatorAccumulator.value.startValidation(instance)

            if (!startValidation) emitValidated(false)
        },
    )

    watch(
        () => afficherSectionGardePartagee.value,
        () => (personne.value.gardePartage = undefined),
    )
</script>
